import ProxyBase from '../../../../../core/proxies/ProxyBase'

class ScoreCompanyProxy extends ProxyBase {
  getHightLight(params) {
    return this.get('Score/Highlight', params)
  }
  getModelLists(params) {
    return this.get('Score/ModelLists', params)
  }
  //Credit Risk Score
  getScoreCreditRisk(params) {
    return this.get('Score/CreditRisk/Score', params)
  }
  getTrendOfScore(params) {
    return this.get('Score/CreditRisk/TrendOfScore', params)
  }
  getDistributionScore(params) {
    return this.get('Score/CreditRisk/DistributionScore', params)
  }

  //ScoreRangesPerformance
  getScorePerformance(params) {
    return this.get('Score/Performance/Score', params)
  }
  getTrendOfScorePerformance(params) {
    return this.get('Score/Performance/TrendOfScore', params)
  }
  getDistributionPerformance(params) {
    return this.get('Score/Performance/DistributionScore', params)
  }

  //CorporateLinkageScore
  getLinkageScore(params) {
    return this.get('Score/LinkageScore', params)
  }
  downloadLinkageScore(params) {
    return this.get('Score/LinkageScore/Export', params, 'download')
  }
}

export default new ScoreCompanyProxy()
